<template>
  <dtunes-modal @openModal = "dialog = true" @closeModal = "dialog = false">
    <template v-slot:button>
      <v-icon>mdi-plus</v-icon>
      Onboard Admin
    </template>
    <template v-slot:content>
      <v-card class="pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">ONBOARD DTUNES ADMINISTRATOR</p>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <label for="">Enter Dtunes Email</label>
            <v-text-field
              color="auto"
              v-model="email"
              :rules="emailRules"
              type="email"
              outlined
            ></v-text-field>
            <label for="">Enter Phone Number</label>
            <v-text-field
              color="auto"
              :rules="phonenumberRules"
              v-model="phonenumber"
              type="tel"
              outlined
            ></v-text-field>
            <v-select
              v-model="value"
              :items="Permissions"
              item-text="name"
              item-value="key"
              :rules="formRules"
              :menu-props="{ maxHeight: '200' }"
              color="auto"
              label="Select Permissions"
              outlined
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ value.length - 1 }} others)
                </span>
              </template>
            </v-select>
            <default-button
              @click="onboardAdmin"
              :loading="loading"
              :disabled="!isComplete"
              >Onboard Admin</default-button
            >
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
// ============= IMPORT COMPONENT ===========
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from "@/components/Buttons/default-button.vue";

// =========== IMPORT SERVICES =============
import { PermissionService, AdminService } from "@/services";

export default {
  components: {
    DtunesModal,
    DefaultButton,
  },
  data: () => ({
    email: "",
    phonenumber: "",
    Permissions: [],
    loading: false,
    value: [],
    emailRules: [],
    phonenumberRules: [],
    formRules: [(v) => !!v || "This field is required"],
  }),
  computed: {
    isComplete() {
      return this.email && this.phonenumber && this.value.length > 0;
    },
  },
  mounted() {
    this.getPermissions();
  },
  methods: {
    async onboardAdmin() {
      try {
        this.loading = true;
        let payload = {
          email: this.email,
          phonenumber: this.phonenumber,
          permissions: this.value,
        };
        const data = await AdminService.onboardAdmin(payload);
        this.loading = false;
        this.email='';
        this.phonenumber='';
        this.value = []
        this.dialog = false;
        this.$emit('reload');
        console.log(data);
      } catch (err) {
        this.loading = false;
        for (const errors in err) {
          let errorName = this[errors];
          this[errors + "Rules"].push(
            (v) => (v && v !== errorName) || err[errors]
          );
          this.$refs.form.validate();
        }
      }
    },
    async getPermissions() {
      const data = await PermissionService.getPermissions();
      this.Permissions = data;
    },
  },
};
</script>